import { FC } from "react";
import classNames from "classnames";

import styles from "./index.less";

import {
  PricingPlanVersionEnum,
  PricingPlanVersionTextMap,
} from "../../../../types";

import BasicPlanIcon from "../../../../assets/icons/basic.svg";
import PlusPlanIcon from "../../../../assets/icons/plus.svg";
import ProPlanIcon from "../../../../assets/icons/pro.svg";
import UltraPlanIcon from "../../../../assets/icons/ultra.svg";

interface VersionPickerProps {
  currentVersion: PricingPlanVersionEnum;
  value?: PricingPlanVersionEnum;
  onChange?: (version: PricingPlanVersionEnum) => void;
}

const Versions = [
  {
    label: PricingPlanVersionTextMap[PricingPlanVersionEnum.BASIC],
    value: PricingPlanVersionEnum.BASIC,
    icon: BasicPlanIcon,
  },
  {
    label: PricingPlanVersionTextMap[PricingPlanVersionEnum.PLUS],
    value: PricingPlanVersionEnum.PLUS,
    icon: PlusPlanIcon,
  },
  {
    label: PricingPlanVersionTextMap[PricingPlanVersionEnum.PRO],
    value: PricingPlanVersionEnum.PRO,
    icon: ProPlanIcon,
  },
  {
    label: PricingPlanVersionTextMap[PricingPlanVersionEnum.ULTRA],
    value: PricingPlanVersionEnum.ULTRA,
    icon: UltraPlanIcon,
  },
];

/**
 * 续费选择版本
 * @returns
 */
const VersionPicker: FC<VersionPickerProps> = ({
  currentVersion,
  value,
  onChange,
}) => {
  return (
    <div className={styles["version-picker"]}>
      {Versions.map((item) => (
        <div
          className={classNames(styles["item"], {
            [styles["item-selected"]]: value === item.value,
          })}
          key={item.value}
          onClick={() => {
            onChange?.(item.value);
          }}
        >
          <img
            src={item.icon}
            alt={item.label}
            style={{
              height: 20,
              width: 20,
            }}
          />
          <div>{item.label}</div>
          {currentVersion === item.value && (
            <div className={styles["current-version"]}>当前版本</div>
          )}
        </div>
      ))}
    </div>
  );
};

export default VersionPicker;
